import { createFileRoute } from "@tanstack/react-router";
import { getCity } from "@/lib/seo/cities";
import { filmbyraForCity } from "@/lib/seo/localAreaCopy";
import { cityHubRoute } from "@/lib/seo/cityHubRoute";

const city = getCity("trollhattan")!;
const page = filmbyraForCity(city);

export const Route = createFileRoute("/filmbyra_/trollhattan")(cityHubRoute(city, page));
